import Attendance from '../../../weon/models/Attendance';

const state = {
  Attendance: new Attendance(),
  agentDetails: null,
  UserAdded: {},
  orgUnitInformation: {
    id: null,
    name: '',
    broadcastWhatsappEnabled: false,
  },
  organia: {
    churnBusterDialog: false,
    churnBusterDontAskAgain: false,
  },
};

export default state;
